<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <el-badge :value="count" :max="99" style="margin-right: 15px;" :hidden="count<=0">
                    <el-button size="mini" :class="form.GiveOut ==2 ?'selected':''" @click="titleClick(2)">待发货</el-button>
                </el-badge>
                <el-button size="mini" style="margin-left: 25px;" :class="form.GiveOut ==1 ?'selected':''" @click="titleClick(1)">已处理</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" plain icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
                <el-button size="medium" type="primary" v-if="form.GiveOut !=1" @click="accGroupOut">批量发货</el-button>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>
        <!-- 列表 -->
        <el-table ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            @selection-change="handleSelectionChange"
            v-loading="listLoading" 
            v-show="form.GiveOut==2||form.GiveOut == 0"
        >
            <!-- eslint-disable  -->
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="奖品名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.PrizeName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PrizeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="获奖来源">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.GroupType" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in GroupTypeArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.GroupTypeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="奖品分类" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.MaterialObject" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in MaterialObjectArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsMaterialObject?'实物':'虚物'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="收货人" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.LinkMan" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.LinkMan || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.HandSet" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.HandSet || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="收货地址" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Address" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Address}}{{scope.row.DetailAddress}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.GiveOut" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in GiveOutArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsGiveOut?'已发货':'未发货'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>


        <el-table ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            v-show="form.GiveOut==1"
        >
            <!-- eslint-disable  -->
            <el-table-column label="奖品名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.PrizeName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PrizeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="获奖来源">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.GroupType" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in GroupTypeArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.GroupTypeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="奖品分类" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.MaterialObject" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in MaterialObjectArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsMaterialObject?'实物':'虚物'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="收货人" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.LinkMan" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.LinkMan || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.HandSet" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.HandSet || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="收货地址" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Address" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Address}}{{scope.row.DetailAddress}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态" >
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.GiveOut" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in GiveOutArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsGiveOut?'已发货':'未发货'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <p style="margin-bottom: -42px;font-size: 14px;line-height: 32px;" v-if="form.GiveOut == 2 || form.GiveOut == 0">已选中 {{num}} 条信息</p>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {
    GetAccPrizeCount,       //获取获奖数量
    GetAccPrizeList,        //获取列表状态
    GroupGiveOut,           //批量发货
} from "@/service/run";
import { 
  getStorageToken,
  getStorageUserRoleId
} from '@/utils/store'
  export default {
    data() {
        return {
            listLoading: false,
            form: {
                PageNum: 1,
                PageSize: 10,

                PrizeName: '',      //奖品名称
                GroupType: '',      //获奖来源 0 全部， 1基础抽奖，2.高级抽奖，4兑换奖品
                MaterialObject: '', //奖品类别 0全部，1实物，2虚物
                LinkMan: '',        //收货人
                HandSet: '',        //收货人联系方式
                Address: '',        //收货地址
                GiveOut: 2,        //状态 0全部，1已发货，2未发货
            },
            searchData:{},
            oraginForm:{},
            count: 0,
            total: 0,                       //总条数
            tableData:[],
            num: 0,                         //选中的数量
            selected_items:{},


            GroupTypeArr:[
                {
                    JobStatus: 1,
                    JobStatusTxt: '基础抽奖'
                },
                {
                    JobStatus: 2,
                    JobStatusTxt: '高级抽奖'
                },
                {
                    JobStatus: 4,
                    JobStatusTxt: '兑换奖品'
                },
            ],
            MaterialObjectArr:[
                {
                    JobStatus: 1,
                    JobStatusTxt: '实物'
                },
                {
                    JobStatus: 2,
                    JobStatusTxt: '虚物'
                },
            ],
            GiveOutArr:[
                {
                    JobStatus: 1,
                    JobStatusTxt: '已发货'
                },
                {
                    JobStatus: 2,
                    JobStatusTxt: '未发货'
                },
            ],
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
        this.handleSearch();
        this.GetPrizeStatus();
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        // 获取列表状态
        GetPrizeStatus(){
            let data = {}
            data.GiveOut = 2
            GetAccPrizeCount(data).then(res=> {
                this.count = res.Data.Count
            })
        },

        titleClick(type){
            this.form.GiveOut = type;
            this.selected_items = {}
            this.num = 0
            this.handleSearch()
        },
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNum = val
            this.searchData.PageNum = val
            this.GetGrantList()
        },
        //翻页
        handleSizeChange(val) {
            if (this.listLoading) return
            this.form.PageNum = 1
            this.form.PageSize = val
            this.searchData.PageNum = 1
            this.searchData.PageSize = val
            this.GetGrantList()
        },
        async GetGrantList(){
            const _this = this;
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))

            !data.PrizeName && delete data.PrizeName
            if(data.GroupType == '') data.GroupType = 0
            if(data.MaterialObject == 0) data.MaterialObject = 0
            !data.LinkMan && delete data.LinkMan
            !data.HandSet && delete data.HandSet
            !data.Address && delete data.Address
            if(data.GiveOut == '') data.GiveOut = 0
            let res = await GetAccPrizeList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }

           const old = JSON.parse(JSON.stringify(this.selected_items));
           this.selected_items = {};

            this.tableData = res.Data.AccPrizeList;
            this.total = res.Data.TotalCount;
            this.num = Object.keys(old).length;
            this.$forceUpdate();
            if (Object.keys(old).length) {
                this.$nextTick(() => {
                    for (var idx1 in _this.tableData) {
                        const item1 = _this.tableData[idx1];
                        if (old[item1.id]) {
                            _this.$refs.tableData.toggleRowSelection(item1);
                        }
                    }
                    for (var key1 in old) {
                        const item2 = old[key1];
                        _this.selected_items[key1] = item2;
                    }
                    _this.num = Object.keys(_this.selected_items).length;
                    _this.$forceUpdate();
                });
            }
            _this.$nextTick(()=>{
                _this.$refs.tableData.doLayout()
            })
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()

            this.selected_items = {};
            this.$forceUpdate();

        },
        // table选中
        handleSelectionChange(val) {
            for (var idx in this.tableData)
            {
                const item = this.tableData[idx];
                if (this.selected_items[item.Id]) delete this.selected_items[item.Id];
            }

            for (var idxs in val)
            {
                const item2 = val[idxs];
                this.selected_items[item2.Id] = item2;
            }
            this.num = Object.keys(this.selected_items).length;
        },

        // 点击批量发货
        accGroupOut(){
            if(JSON.stringify(this.selected_items) == '{}') {
                return this.$message.error('请选择收货人')
            }
            let data = {
                IdArray: [],
            }
            for (var key in this.selected_items) {
                const item = this.selected_items[key];
                console.log(item)
                data.IdArray.push(item.Id)
            }
            this.$confirm('确认要发货吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                GroupGiveOut(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.GetGrantList()
                    this.GetPrizeStatus()
                })
            }).catch(() => {});
        },
        // 点击下载
        downloadFile() {
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.PrizeName && delete data.PrizeName
            if(data.GroupType == '') data.GroupType = 0
            if(data.MaterialObject == 0) data.MaterialObject = 0
            !data.LinkMan && delete data.LinkMan
            !data.HandSet && delete data.HandSet
            !data.Address && delete data.Address
            if(data.GiveOut == '') data.GiveOut = 0

            let url = process.env.NODE_ENV == "development" ? "/api4" : process.env.VUE_APP_API4;
            window.open(
                url + "/api/AccPrize/DownAccPrize" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
                Object.keys(json).map(function (key) {
                    if (json[key] === undefined) return "";
                        return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
                    })
                ).join("&");
        },
        cleanArray(actual) {
            var newArray = [];
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .section-box {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>